import { Link } from "react-router-dom";
import { 
  Wrench, Zap, Trees, Sparkles, Fan, Home, Paintbrush, Square, 
  Hammer, Layers, Boxes, PanelTop, Lock, Bug, Refrigerator,
  Fence, Trash2, Shovel, DoorOpen
} from "lucide-react";

const iconMap = {
  Wrench: Wrench,
  Zap: Zap,
  Trees: Trees,
  Sparkles: Sparkles,
  Fan: Fan,
  Home: Home,
  Paintbrush: Paintbrush,
  Square: Square,
  Hammer: Hammer,
  Layers: Layers,
  Boxes: Boxes,
  PanelTop: PanelTop,
  Lock: Lock,
  Bug: Bug,
  Refrigerator: Refrigerator,
  Fence: Fence,
  Trash2: Trash2,
  Shovel: Shovel,
  DoorOpen: DoorOpen,
};

export const CategoryCard = ({ category, size = "default" }) => {
  const IconComponent = iconMap[category.icon] || Wrench;

  if (size === "large") {
    return (
      <Link
        to={`/directory?category=${category.category_id}`}
        className="group relative overflow-hidden rounded-2xl h-64 block"
        data-testid={`category-card-${category.slug}`}
      >
        {/* Background Image */}
        <div className="absolute inset-0">
          {category.image_url ? (
            <img
              src={category.image_url}
              alt={category.name}
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
            />
          ) : (
            <div className="w-full h-full bg-gradient-to-br from-[#1A4D2E] to-[#143D24]" />
          )}
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />
        </div>

        {/* Content */}
        <div className="absolute bottom-0 left-0 right-0 p-6">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-10 h-10 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center">
              <IconComponent className="w-5 h-5 text-white" />
            </div>
            <h3 className="font-bold text-xl text-white">{category.name}</h3>
          </div>
          <p className="text-white/80 text-sm line-clamp-2">{category.description}</p>
        </div>

        {/* Hover overlay */}
        <div className="absolute inset-0 bg-[#1A4D2E]/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      </Link>
    );
  }

  return (
    <Link
      to={`/directory?category=${category.category_id}`}
      className="group flex items-center gap-4 p-4 bg-white rounded-xl border border-stone-200 hover:border-[#1A4D2E]/30 hover:shadow-md transition-all duration-300"
      data-testid={`category-card-${category.slug}`}
    >
      <div className="w-12 h-12 bg-[#1A4D2E]/10 rounded-xl flex items-center justify-center group-hover:bg-[#1A4D2E] transition-colors duration-300">
        <IconComponent className="w-6 h-6 text-[#1A4D2E] group-hover:text-white transition-colors duration-300" />
      </div>
      <div>
        <h3 className="font-semibold text-[#1A1A1A] group-hover:text-[#1A4D2E] transition-colors">
          {category.name}
        </h3>
        <p className="text-[#71717A] text-sm">{category.description}</p>
      </div>
    </Link>
  );
};

export default CategoryCard;
